import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';
import { AuthService } from '../services/auth.service';
import { HttpStatus } from '../constants/http-status';
import { ResponseMessages } from '../constants/messages';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        const isLoginRequest = req.url.includes('/auth/login');

        switch (error.status) {
          case HttpStatus.UNAUTHORIZED:
            // Auto logout and redirect to login if 401 Unauthorized for authenticated session requests
            if (!isLoginRequest) {
              authService.logout();
              messageService.add({
                severity: 'warn',
                summary: 'Session Expired',
                detail: ResponseMessages.UNAUTHORIZED
              });
              router.navigate(['/login'], { queryParams: { returnUrl: router.url } });
            }
            break;

          case HttpStatus.FORBIDDEN:
            // Auto logout and redirect to login if 403 Forbidden
            authService.logout();
            messageService.add({
              severity: 'error',
              summary: 'Access Denied',
              detail: ResponseMessages.FORBIDDEN
            });
            router.navigate(['/login']);
            break;

          case HttpStatus.INTERNAL_SERVER_ERROR:
          case HttpStatus.BAD_GATEWAY:
          case HttpStatus.SERVICE_UNAVAILABLE:
          case HttpStatus.GATEWAY_TIMEOUT:
            // Redirect to server-error page for severe server errors
            router.navigate(['/server-error']);
            break;

          default:
            // Other errors (e.g. 400 Bad Request, 404 Not Found) are handled at component level
            break;
        }
      }
      return throwError(() => error);
    })
  );
};
